export default __webpack_public_path__ + "static/pipeline-dashboard-slider-2-c730f731a2a9fe6128aea61bad5d4c49.mp4";